// extracted by mini-css-extract-plugin
export default {"generalContainer":"downloadWallet_generalContainer__vDF9e","downloadWalletContainer":"downloadWallet_downloadWalletContainer__8w9F4"};